import { I18n } from 'shared'

export const language = () => {
  if (/^en/.test(I18n.locale)) {
    return 'en-EN'
  } else {
    return 'de-DE'
  }
}
